export default function Header(props) {
  return (
    <section>
      <div className="header header1">
        Hi, I'm <div className="hl">Chen Gao</div>
      </div>
      <div className="header header2">
        An Aspiring <div className="hl">Software Engineer</div>
      </div>
    </section>
  );
}
